import Image from 'next/image';
import { useMobile } from 'hooks';
import { NextLinkComposed, Spacer } from '@features/shared';
import { Box, Button } from '@material-ui/core';
import React from 'react';
import { urls } from '@features/libs/urls';
import { Typography } from '../../../../src/design-system/atoms';

function PasswordChangedSuccessfully() {
  const isMobile = useMobile();
  return (
    <div>
      <Spacer spacing={isMobile ? 5 : 9} />
      <Box display="flex" justifyContent="center">
        <Image
          width={128}
          height={128}
          src="/assets/authentication/person-check.svg"
          unoptimized
        />
      </Box>

      <Spacer spacing={isMobile ? 2 : 3} />

      <Typography
        component="div"
        variant="h5"
        align={isMobile ? 'left' : 'center'}
      >
        <Box fontWeight="fontWeightMedium">
          Contraseña cambiada exitosamente
        </Box>
      </Typography>

      <Spacer spacing={isMobile ? 1 : 2} />
      <Typography variant="body2" align={isMobile ? 'left' : 'center'}>
        Ya puede iniciar sesión con su nueva contraseña
      </Typography>
      <Spacer spacing={isMobile ? 2 : 3} />
      <Button
        component={NextLinkComposed}
        variant="contained"
        color="primary"
        fullWidth
        to={urls.login}
      >
        Iniciar sesión
      </Button>
    </div>
  );
}

export default PasswordChangedSuccessfully;
